import React, { useState } from 'react';
import BlogLink from '../../BlogLink';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';
import ListTable from './ListTable';



function Labyrinth() {


  // 変更する
  // ---------------------------------------------
  // 2023.3.22
  // 1040,31200(sum,cost)

  // s10,team_a,a,gold,energy,ticket,point,coin,trap
  const getRate = [0.017094017094017096, 0.008547008547008548, 0.017094017094017096, 0.02564102564102564, 0.1282051282051282, 0.09401709401709402, 98.2905982905983, 136.75213675213675, 0.27350427350427353]; //獲得数/初期所持メダル

  const cost = 3; //コスト/1周
  const boxNumInit = 10 / 3; //BOX/1周
  const expInit = 5230.0 //ストック経験値/1周


  // 表示設定
  // ---------------------------------------------
  // const [digits, setDigits] = useState(0);
  const digits = 0;
  const [energy, setEnergy] = useState(250);
  const [boxNum, setBoxNum] = useState(boxNumInit);
  const [exp, setExp] = useState(expInit);
  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------
  // const needMedal = 3;
  const returnRate = getRate[4] * boxNum//1周(3エナジー)あたり何エナジー返ってくるか

  // ---------------------------------------------

  //   集計
  const getRatePerEnergy = [];
  for (let i = 0; i < getRate.length; i++) {
    getRatePerEnergy[i] = getRate[i] * boxNum //1周(3エナジー)あたりi等が何回当たるか
  }


  //   実質消費エナジー
  const realEnergy = (3 - returnRate);

  //   消費エナジー変更
  const handleEnergyChange = (event) => {
    setEnergy(event.target.value);
  };

  //   桁数変更
  // const handleDigitsChange = (event) => {
  //   if (event.target.value >= 0) {
  //     var dig = event.target.value;
  //   } else {
  //     var dig = 0;
  //   }
  //   setDigits(dig);
  // };


  const calculateItem = () => {
    const getItemPerRealEnergy = [];
    const getItemExpected = [];
    for (let i = 0; i < getRate.length; i++) {
      // getItemPerRealEnergy[i] = getItem[i] / realEnergy;
      getItemPerRealEnergy[i] = getRatePerEnergy[i] / realEnergy; //後で修正

      getItemExpected[i] = ((getItemPerRealEnergy[i] * energy)).toFixed(digits);
    }
    console.log(getItemPerRealEnergy)

    return getItemExpected
  }

  // s10,team_a,a,gold,energy,ticket,point,coin,trap

  const getItemExpected = calculateItem()

  const itemExpectedList = [
    { name: 'ストック経験値', result: (exp * (energy / realEnergy)).toFixed(digits) },
    { name: 'Sランク10％契約書', result: getItemExpected[0] },
    { name: '自A契約書', result: getItemExpected[1] },
    { name: 'A契約書', result: getItemExpected[2] },
    { name: 'ゴールド契約書', result: getItemExpected[3] },
    { name: '試練チケット', result: getItemExpected[5] },
    { name: 'スカウトP', result: getItemExpected[6] },
    { name: 'コイン', result: getItemExpected[7] },
    { name: '罠', result: getItemExpected[8] },
  ];

  return (
    <>
      <Base body={
        <Container>
          <h1>ラビリンス</h1>
          <Label>
            <Text>消費エナジー：</Text>
            <Input type="number" value={energy} onChange={handleEnergyChange} />
          </Label>

          < div >
            <h2>計算結果</h2>
            <ListTable list={itemExpectedList} />
          </div >
          <Result>
            <Text>エナジー還元率:{(returnRate / cost).toFixed(3)}</Text>
          </Result>
          <div>
            <p>{energy}エナジー消費した時に得られるアイテム数の期待値がResultに表示されます。</p>
          </div>
          <BlogLink link={"https://www.sakusaku27.com/"} />
        </Container>

      } title="ラビリンス" />
    </>
  );
}

export default Labyrinth;
